'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entity = require('conversations-core/reducers/utils/entity');

var _entity2 = _interopRequireDefault(_entity);

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = (0, _immutable.Map)();

exports.default = (0, _entity2.default)('smartLists', (0, _reduxActions.handleActions)({}, initialState));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/smartLists.js
// module id = 518
// module chunks = 0